import { ActorFilterRegistryCategory } from '../ActorFilterRegistryCategory';
import { ActorFilterRegistryItem } from '../ActorFilterRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class ActorFilterMultipleChoice extends ActorFilterRegistryCategory {
    label = 'MultipleChoice';
    constructor(parent) {
        super(parent);
        for (let n = 1; n <= 8; n++) {
            this[`option${n}`] = () => new ActorFilterRegistryItem({
                filter: ({ a }) => a instanceof runtime.class.BasicOption && a.shuffledOptionNumber === n
            });
        }
        super.init();
    }
    option_text = () => new ActorFilterRegistryItem({
        label: 'Option > Text',
        filter: ({ a }) => a.type === 'text' && a.context.parentActor.type === 'option'
    });
    option_image = () => new ActorFilterRegistryItem({
        label: 'Option > Image',
        filter: ({ a }) => a.type === 'image' && a.context.parentActor.type === 'option'
    });
    option_inner_content = () => new ActorFilterRegistryItem({
        label: 'Option_inner > Content',
        filter: ({ a }) => a instanceof runtime.class.AttachedContent &&
            a.context.parentActor.type === 'option' &&
            a.aspect.name === 'inner'
    });
    option_correctUI = () => new ActorFilterRegistryItem({
        label: 'Option Correct UI',
        filter: ({ a }) => a instanceof runtime.class.BasicOption && a.optionUI.shouldOptionBeGreen
    });
}
